var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTaxesAndCommision24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_taxes_and_commision24x24",
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(3 4)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M211.973,86.946a3.473,3.473,0,1,0-3.473-3.473A3.473,3.473,0,0,0,211.973,86.946Zm.982-2.017-.491-.491.491-.491.491.491Zm-1.964-2.947.491.491-.491.491-.491-.491Zm2.456-.491.491.491L210.5,85.42l-.491-.491Zm0,0",
    transform: "translate(-198.835 -76.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M16.5,256h6.251v1.389H16.5Zm0,0",
    transform: "translate(-15.805 -244.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M16.5,160h6.251v1.389H16.5Zm0,0",
    transform: "translate(-15.805 -153.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M11.626,6.251A3.126,3.126,0,1,0,8.5,3.126a3.126,3.126,0,0,0,3.126,3.126Zm0-2.778a1.039,1.039,0,0,1-.347-2.02V.695h.695v.758a1.041,1.041,0,0,1,.695.978h-.695a.347.347,0,1,0-.347.347,1.039,1.039,0,0,1,.347,2.02v.758h-.695V4.8a1.041,1.041,0,0,1-.695-.978h.695a.347.347,0,1,0,.347-.347Zm0,0",
    transform: "translate(-8.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M.5,208H6.751v1.389H.5Zm0,0",
    transform: "translate(-.5 -198.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M208.5,288h6.251v1.389H208.5Zm0,0",
    transform: "translate(-198.835 -275.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M224.5,336h6.251v1.389H224.5Zm0,0",
    transform: "translate(-214.141 -321.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M181.362,57.724a4.862,4.862,0,1,0-4.862-4.862A4.862,4.862,0,0,0,181.362,57.724Zm0-9.03a4.168,4.168,0,1,1-4.168,4.168A4.168,4.168,0,0,1,181.362,48.695Zm0,0",
    transform: "translate(-168.224 -45.916)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTaxesAndCommision24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_taxes_and_commision24x24.4b8c337637acb22db98d1df5e4420c5c.svg";